import { Alert } from '@designsforhealth/dfh-react-components'
import { Subscribe } from '@react-rxjs/core'
import React, { FC } from 'react'

import { useSelectableTokenBaseCards } from '../../../../lib/cybersource/cards'
import ErrorRetrievingDataMessage from '../../../ErrorRetrievingDataMessage'
import Spacer from '../../../Spacer'
import Spinner from '../../../Spinner'
import CreditCards from './CreditCards'
import EmptyCreditCards from './EmptyCreditCards'

const CreditCardsContainerReactive: FC = () => {
  const { data, error, errors } = useSelectableTokenBaseCards()

  return (
    <div>
      <h3>Credit Cards</h3>
      <Spacer size={3} />
      {(!!error || (!data && errors?.length)) && (
        <Alert type="error">
          <ErrorRetrievingDataMessage />
        </Alert>
      )}
      {!data ? null : data.length ? <CreditCards creditCards={data} /> : <EmptyCreditCards />}
    </div>
  )
}

export const CreditCardsContainer: React.FC = () => (
  <Subscribe fallback={<Spinner loading />}>
    <CreditCardsContainerReactive />
  </Subscribe>
)
